<template>
    <ol class="horizontal-stepper">
        <li
            v-for="(step, index) in steps"
            :key="`${step.name || step.title || 'step'}-${index}`"
            :class="stepClasses(index, step)">
            <span class="horizontal-stepper__index">
                {{ index + 1 }}
            </span>
            <span class="horizontal-stepper__content">
                <span class="horizontal-stepper__title">{{ step.title }}</span>
                <span v-if="step.name" class="horizontal-stepper__subtitle">{{ step.name }}</span>
            </span>
        </li>
    </ol>
</template>

<script>
export default {
    name: "HorizontalStepper",
    props: {
        steps: {
            type: Array,
            default: () => [],
        },
        currentStep: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            currentIndex: this.currentStep?.index ?? 0,
        };
    },
    watch: {
        currentStep: {
            immediate: true,
            deep: true,
            handler(step) {
                if (typeof step?.index === "number") {
                    this.currentIndex = step.index;
                }
            },
        },
    },
    methods: {
        activateStep(index) {
            this.currentIndex = index;
        },
        stepClasses(index, step) {
            return {
                "horizontal-stepper__step": true,
                "horizontal-stepper__step--active": index === this.currentIndex,
                "horizontal-stepper__step--completed": step.completed || index < this.currentIndex,
            };
        },
    },
};
</script>

<style scoped>
.horizontal-stepper {
    display: flex;
    gap: 0.75rem;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow-x: auto;
}

.horizontal-stepper__step {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 0;
    padding: 0.5rem 0.75rem;
    border-radius: 999px;
    background: #f5f5f7;
    color: #6c757d;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.horizontal-stepper__step--completed {
    background: rgba(40, 167, 69, 0.12);
    color: #1f6f3d;
}

.horizontal-stepper__step--active {
    background: #083e60;
    color: #ffffff;
}

.horizontal-stepper__index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
}

.horizontal-stepper__step:not(.horizontal-stepper__step--active) .horizontal-stepper__index {
    background: #ffffff;
}

.horizontal-stepper__content {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.horizontal-stepper__title {
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
}

.horizontal-stepper__subtitle {
    font-size: 0.75rem;
    line-height: 1.2;
    opacity: 0.85;
}
</style>
